const formLink = document.getElementById("show-form");
const originDropdownLink = document.getElementById("show-origin-dropdown");
const originDropdown = document.querySelector(".carry-us-origin");
const originMenuLinks = document.querySelectorAll(".origin-menu-link");
const form = document.querySelectorAll(".form-active");
const notForm = document.querySelectorAll(".form-inactive");
const successMessage = document.querySelector(".form-message--success");
const empty_error = document.querySelector('.carry-us-form')?.dataset.error;
const invalid_error = document.querySelector('.carry-us-form')?.dataset.invalid;
const invalid_range = document.querySelector('.carry-us-form')?.dataset.invalidRange;


console.log('empty_error',empty_error);
if(formLink != null) {
    console.log('formLink', formLink)
  formLink.onclick = function(event){
      event.preventDefault();
      form.forEach((nf) => { nf.classList.remove("inactive");})
      form.forEach((nf) => { nf.classList.add("active");})
      
      notForm.forEach((nf) => { nf.classList.add("inactive");})
      successMessage.classList.remove("active")
      return
  }
}
if(originDropdownLink != null){
  originDropdownLink.onclick = function(event){
      event.preventDefault();
      
      originDropdown.classList.remove("inactive")
      return
  }
  originMenuLinks.forEach(origin => {
    origin.addEventListener("click", setOriginCache)
  });
}

// Open ByDefault -> if form has validation Error or submit Successfully
var url = window.location.href; 
if (url.match(/\?./)) {
    form.forEach((nf) => { nf.classList.remove("inactive");})
    form.forEach((nf) => { nf.classList.add("active");})
   
    notForm.forEach((nf) => { nf.classList.add("inactive");})
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const contact_posted = urlParams.get('contact_posted')
if(contact_posted) {
    notForm.forEach((nf) => { nf.classList.remove("inactive");})
    
    form.forEach((nf) => { nf.classList.remove("active");})
    form.forEach((nf) => { nf.classList.add("inactive");})
    document.getElementById("show-form").parentElement.classList.add("inactive")
   
   
    successMessage.classList.add("active")
}

// Form Validation
const inputRequiredFields = [...document.querySelectorAll(".contact-form__wrapper .field--input input[required]")];
inputRequiredFields.forEach( field => {
    field.addEventListener('keyup', function(){
        if(field.value.trim() === ''){
            setErrorFor(field);
        }else {
            setSuccessFor(field);
        }

        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                const errorMessage = invalid_error;
                setErrorFor(field, errorMessage);
            }else {
                setSuccessFor(field);
            }
        }
    })
})

const carryUsForm = document.getElementById("contact_form");
let isValid = true;

function validateForm (e) {
      isValid = true;
      e.preventDefault();
      checkInputs();
      validPrice();
      validateRequiredPrices();
    //   console.log(isValid)
      if(isValid){
        carryUsForm.submit();
        return true;
      }else {
        focusForm();  
        return false;
      }
}

function checkInputs() {
    const requiredFields = document.querySelectorAll(".contact-form__wrapper .field--input input[required]");
    const inputFields = [...requiredFields] 
    inputFields.forEach( field => {
        if(field.value.trim() === ''){
            setErrorFor(field);
        }else {
            setSuccessFor(field);
        }

        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                const errorMessage = invalid_error;
                setErrorFor(field, errorMessage);
            }else {
                setSuccessFor(field);
            }
        }
    });
}

function validateRequiredPrices(){
    // console.log('validate required price')
    const lowPrice = document.querySelector(".contact-form__wrapper .field--input #lower-haircut-price");
    const highPrice = document.querySelector(".contact-form__wrapper .field--input #highest-haircut-price");
    if(lowPrice.value != '' && highPrice.value == '') {
            const formControl = highPrice.parentElement;
            formControl.classList.add('error');
            const label = formControl.querySelector('label');
            const message = `${label.textContent}` + ` ${empty_error}`;
            const esmall = formControl.querySelector('small');
            esmall.innerText = message;
            isValid = false;
    }else if(lowPrice.value == '' && highPrice.value != '') {
            const formControl = lowPrice.parentElement;
            formControl.classList.add('error');
            const label = formControl.querySelector('label');
            const message = `${label.textContent}` + ` ${empty_error}`;
            const esmall = formControl.querySelector('small');
            esmall.innerText = message;
            isValid = false;
    }else {
        const lformControl = lowPrice.parentElement;
        lformControl.classList.remove('error');
        const hformControl = highPrice.parentElement;
        hformControl.classList.remove('error');
    }
}

function setErrorFor(input, errorMessage = '') {
  const formControl = input.parentElement;
  const small = formControl.querySelector('small');
  formControl.classList.add('error');
  
  const label = formControl.querySelector('label');
  const messagePrefix =  label.textContent.replace("*", "");
  const message = `${messagePrefix}` + ` ${empty_error}`
  small.innerText = errorMessage != '' ? errorMessage : message;
  isValid = false;
}

function setSuccessFor(input) {
  const formControl = input.parentElement;
  const small = formControl.querySelector('small');
  small.innerText = ''
  formControl.classList.remove('error');
}
function focusForm(){
    const inputRequiredFields = [...document.querySelectorAll(".contact-form__wrapper .field--input input[required]")];
    let  inValidElem = []
    inputRequiredFields.forEach( field => {
        if(field.value.trim() === ''){
            inValidElem.push(field)
        }   
        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                inValidElem.push(field)
            }
        }    
    })
    if(inValidElem.length > 0) { inValidElem[0].focus(); }   
}

function isEmail(email) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
}

function isPhone(evt){
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode == 43){
        return true;
    } else {
        return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }
    
}
function validPrice(event){
    const lowPrice = document.querySelector(".contact-form__wrapper .field--input #lower-haircut-price");
    const highPrice = document.querySelector(".contact-form__wrapper .field--input #highest-haircut-price");
   
    const lformControl = lowPrice.parentElement;
    const hformControl = highPrice.parentElement;
    lformControl.classList.remove('error');
    lformControl.querySelector('small').innerText = '';
    hformControl.classList.remove('error');
    hformControl.querySelector('small').innerText = '';

    let formControl = document.querySelector('.price-error');
    const small = formControl.querySelector('small');
    
    if(Number(lowPrice.value) > Number(highPrice.value) && lowPrice.value != '' && highPrice.value != ''){
        
        formControl.classList.add('error');
        const message = `${invalid_range}`
        small.innerText = message;
        isValid = false;
    }else {
        formControl.classList.remove('error');
        small.innerText = '';
    }
}
var numbers = document.querySelectorAll('.input-number');

numbers.forEach( number => {
    number.onkeydown = function(e) {
        if(!((e.keyCode > 95 && e.keyCode < 106)
          || (e.keyCode > 47 && e.keyCode < 58) 
          || e.keyCode == 8)) {
            return false;
        }
    }
})

function setOriginCache(evt){
  localStorage['originStockist'] =  this.dataset.origin; 
}